export const sortCategories = [
    { name: 'All', id: 'all', arrow: false, asc: true },
    { name: 'Billing Date', id: 'billingDate', arrow: false, asc: true },
    { name: 'Amount', id: 'amount', arrow: false, asc: true },
]